function Dev(message) {
  const __DEV__ = false;
  if (__DEV__ === true) {
    console.log(message);
  }
}
const Log = {
  Dev
};
export default Log;
